<template>
  <div
    :data-tint="tint"
    class="bg-primary/25 dark:bg-primary-400 @container/partner-container flex flex-col inset-shadow-sm"
    :class="[$attrs.class, outerElementClass]"
  >
    <div class="flex shrink-0 flex-col gap-3 @md/partner-container:flex-row">
      <div
        v-if="$slots['top-left-cta']"
        class="flex shrink-0 flex-row items-center empty:hidden"
      >
        <slot name="top-left-cta"></slot>
      </div>
      <div class="flex shrink-0 items-center dark:rounded dark:bg-white">
        <img :src="partnersLogo" :class="logoSize" />
      </div>
      <div
        v-if="$slots['top-right-cta']"
        class="flex flex-1 justify-end empty:hidden"
      >
        <slot name="top-right-cta"></slot>
      </div>
    </div>
    <div v-if="$slots['header']">
      <slot name="header" />
    </div>
    <div class="relative min-h-0 flex-1">
      <div
        v-if="loading"
        class="border-primary/50 bg-primary-300/25 absolute inset-0 z-20"
        :class="{
          innerContainerClass,
          'p-3': $slots['header']
        }"
      >
        <LoadingComponent size="small" :label="'loading data'" />
      </div>
      <div
        id="partner-container-default"
        class="flex flex-col gap-3"
        :class="[
          innerContainerClass,
          scrollable ? 'absolute inset-0 overflow-y-auto' : '',
          backgroundColored
            ? 'bg-white/75 dark:bg-white/25'
            : 'bg-white dark:bg-slate-800'
        ]"
      >
        <slot name="default" />
      </div>
    </div>
    <div
      v-if="$slots['bottom-left-cta'] || $slots['bottom-right-cta']"
      class="flex shrink-0 flex-row gap-1"
    >
      <div class="flex flex-1 flex-row items-center">
        <slot name="bottom-left-cta"></slot>
      </div>
      <div class="shrink-0">
        <slot name="bottom-right-cta"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingComponent from '@c/TheLoadingComponent.vue'
import PartnersLogo from '../../assets/enums/config/PartnersLogo'

export default {
  name: 'PartnerContainer',
  components: { LoadingComponent },
  props: {
    partnersLogo: {
      type: String,
      required: false,
      default: null
    },
    tint: {
      type: String,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    scrollable: {
      type: Boolean,
      require: false,
      default: false
    },
    backgroundColored: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  computed: {
    PartnersLogo() {
      return PartnersLogo
    },
    outerElementClass() {
      switch (this.size) {
        case 'extra-small':
          return 'squircle-lg rounded p-1.5 gap-1.5'
        case 'small':
          return 'squircle-lg rounded p-2 gap-2'
        case 'large':
          return 'squircle-lg rounded-lg p-4 gap-3'
        case 'extra-large':
          return 'squircle-xl rounded-xl p-[1.125rem] gap-[1.125rem]'
        case 'medium':
        default:
          return 'squircle-md rounded-md p-3 gap-3'
      }
    },
    innerContainerClass() {
      switch (this.size) {
        case 'extra-small':
          return 'squircle-lg rounded p-1.5 '
        case 'small':
          return 'squircle-lg rounded p-2'
        case 'large':
          return 'squircle-lg rounded-lg p-4'
        case 'extra-large':
          return 'squircle-xl rounded-xl p-[1.125rem]'
        case 'medium':
        default:
          return 'squircle-sm rounded-md p-3'
      }
    },
    logoSize() {
      switch (this.size) {
        case 'extra-small':
          return 'h-4'
        case 'small':
          return 'h-5'
        case 'large':
          return 'h-8'
        case 'extra-large':
          return 'h-10'
        case 'medium':
        default:
          return 'h-6'
      }
    }
  }
}
</script>
